<template>
  <div class="store-skeleton-component">
    <div class="h5"><StoreSkeletonH5 /></div>
    <div class="pc"><StoreSkeletonPc /></div>
  </div>
</template>
<script>
import StoreSkeletonH5 from './storeSkeletonH5.vue';
import StoreSkeletonPc from './storeSkeletonPc.vue';
export default {
  name: 'StoreSkeleton',
  components: {
    StoreSkeletonH5,
    StoreSkeletonPc,
  },
};
</script>
<style lang="scss" scoped>
.store-skeleton-component {
  .h5 {
    display: none;
  }
}
@media screen and (max-width: 768px) {
  .store-skeleton-component {
    .h5 {
      display: block;
    }
    .pc {
      display: none;
    }
  }
}
</style>
